import { useMemo } from 'react';
import {
  hasPermission,
  hasAnyPermission,
  hasAllPermissions,
  getPermissionsForRole,
  Permission,
} from '@klaro7/shared-types';

import { useAuth } from '../auth/hooks/useAuth';

export function usePermissions() {
  const { user } = useAuth();

  const permissions = useMemo(() => {
    if (!user) return [];
    return getPermissionsForRole(user.role);
  }, [user]);

  const can = (permission: Permission): boolean => {
    if (!user) return false;
    return hasPermission(user.role, permission);
  };

  const canAny = (perms: Permission[]): boolean => {
    if (!user) return false;
    return hasAnyPermission(user.role, perms);
  };

  const canAll = (perms: Permission[]): boolean => {
    if (!user) return false;
    return hasAllPermissions(user.role, perms);
  };

  const isAdmin = useMemo(() => {
    return can(Permission.ADMIN_ACCESS);
  }, [user]);

  return {
    permissions,
    can,
    canAny,
    canAll,
    isAdmin,
  };
}
